// extracted by mini-css-extract-plugin
export default {"clients":"Clients_clients__o1Kza","buttonsContainer":"Clients_buttonsContainer__p9FIQ","margin10":"Clients_margin10__y2slH"};